import React, { Component } from 'react';
import './ReturnPolicy.css';
import {Helmet} from "react-helmet";

export default class ReturnPolicy extends Component {
    render() {
        return (
            <div id="return-policy">
            <Helmet>
                <title>Terms of Use - HelloAva</title>
            </Helmet>
                <h1>Return Policy</h1>
                <div className="return-section">
                	<h2>Returns</h2>
                	<p>Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately, we can’t offer you a refund or exchange.</p>
					<p>To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging. However, if your product causes a sensitive reaction, we will evaluate the situation and process the return on a case by case basis.
					Purchase of sale, non-regular priced items are final. No returns or exchanges of these items.
					</p>
					<p>To complete your return, we require a receipt or proof of purchase (email receipt works).</p>
					<p>There are certain situations where only partial refunds are granted:</p> 
					<ul>
						<li>Any item not in its original condition, is used, damaged or missing parts for reasons not due to our error. </li>
						<li>Any item that is returned more than 30 days after delivery</li>
					</ul>
				</div>
				<div className="return-section">
                	<h2>Refunds</h2>
                	<p>Once your return is received and inspected, we will send you an email or text to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.</p> 
					<p>If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days.</p>
                </div>
                <div className="return-section">
                	<h3>Late or missing refunds</h3>
                	<p>
                	If you haven’t received a refund yet, first check your bank account again. 
					Then contact your credit card company, it may take some time before your refund is officially posted.
					</p> 
					<p>
					Next contact your bank. There is often some processing time before a refund is posted. 
					If you’ve done all of this and you still have not received your refund yet, please contact us at <a href="mailto:customersuccess@helloava.co">customersuccess@helloava.co</a>.
                	</p>
                </div>
                <div className="return-section">
                <h2>Exchanges</h2>
	                <p>
	                	We only replace items if they are defective or damaged, or causes allergic reactions. If you need to exchange it for the same item, send us an email at <a href="mailto:customersuccess@helloava.co">customersuccess@helloava.co</a> and send your item to: 110 Wall Street, 2nd Floor, New York, NY 10005
	                </p>
	            </div>
	            <div className="return-section">
                <h2>Gifts</h2>
	                <p>If the item was marked as a gift when purchased and shipped directly to you, you’ll receive a gift credit for the value of your return. Once the returned item is received, a gift certificate will be mailed to you.</p>
					<p>If the item wasn’t marked as a gift when purchased, or the gift giver had the order shipped to themselves to give to you later, we will send a refund to the gift giver and he will find out about your return.</p>
                </div>
                <div className="return-section">
                	<h2>Shipping</h2>
                	<p>To return your product, you should request a return label by texting us or Facebook messaging us and then mail your product to: 110 Wall Street, 2nd Floor, New York, NY 10005.</p>
					<p>You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.</p>
					<p>Depending on where you live, the time it may take for your exchanged product to reach you, may vary.</p>
					<p>If you are shipping an item over $200, you should consider using a trackable shipping service or purchasing shipping insurance. We don’t guarantee that we will receive your returned item.</p>
            	</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/return/ReturnPolicy.js